



export { axios, API, Loading, getSession, SUCCESS_REPONSE_CODE, useRouter, REDIRECT, useState, useTranslation, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode,  toastr, UNAUTHORIZED_REPONSE_CODE, useEffect, useSWR, clearSWRCache, TRANSLATION, Yup, ErrorPages, ClientDashboard, Image, motion, PAGE_ANIMATION_OPTIONS, Tooltip, Link, SendRequest, BrowserDetect, useUser, CustomToastrAction} from '@/imports-files/common/common';

export { COMMUNICATIONS } from '@/constants/pages/clients/communication';

// ------------------- COMPONENTS -------------------
    export { default as DataTable } from 'react-data-table-component';
    export { CommunicationCenterOptions } from "@/components/datatableActionOptions/commuication-center";
    export { CommunicationBulkActionModal } from '@/components/bulk-action-modal/communication-bulk-action';
    export { default as Checkbox } from "@material-ui/core/Checkbox";
    export { ConfirmationModal } from '@/components/confirmation-modal';
    export { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
    export { default as sanitizeHtml }  from 'sanitize-html';
    export { default as parse } from 'html-react-parser';
    export { default as EllipsisText } from "react-ellipsis-text";
    export { EmailsDetailsOptions } from '@/components/datatableActionOptions/email-details';
    export {CandidateEmail} from "@/components/candidate-email";
    export { default as Doc } from "public/icons/document.png";
// ------------------- COMPONENTS -------------------

// ------------------- ACTIONS -------------------
export { getColumnsName, setDataTableClass } from '@/actions/pages/clients/jobs/job';
export { EmailDetailsAction } from '@/actions/pages/clients/communication/email-detail';
// ------------------- ACTIONS -------------------

// ------------------- SERVICE -------------------
export { EmailDetailsService } from '@/services/pages/clients/communication/email-details';
    export { DownloadFileFromEmail } from "@/services/common/download-file-from-email";
// ------------------- SERVICE -------------------


// ------------------- IMAGES -------------------
export { default as Filter } from 'public/icons/filter.svg';
export { default as ArrowLeft } from 'public/icons/arrowleft.svg';
export { default as Star } from 'public/icons/star.svg';
export { default as StarFilled }from 'public/icons/starfilled.svg';
export { default as TripleDots } from 'public/icons/tripledots.svg';
 export { default as Dots} from 'public/icons/dots.svg';
   // ------------------- IMAGES -------------------


export { default as PageStyle } from '@/styles/pages/clients/email-chain/_index.module.scss';
export { default as Button } from '@/components/button';
export { default as ButtonStyle } from "@/styles/components/button/_index.module.scss";


